'use strict';

import * as domUtils from '../util/dom';
var device = require('../util/device');
var Sizzle = require('sizzle');
import * as UIConstants from './ui/ui-constants';
var EVENT_NAMESPACE = 'pip';

var CLASSNAMES = {
	pipButton: 'svp_js-pip--btn',
	pipButtonLabel: 'svp_js-pip--btn-label',
	placeholderContainer: 'svp_js-pip--placeholder-container'
};

var BUTTON_ICONS = {
	pipButton: 'svp_pictureinpicture-button',
	pipButtonEnd: 'svp_pictureinpicture-button-end'
};

module.exports = {
	create: function (api) {

		function _getElement(className) {
			return api && Sizzle('.' + className, api.element())[0];
		}

		api.once(EVENT_NAMESPACE + '.canplay', function () {

			if (device.isPictureInPictureCapable(api.video())) {
				var pipButton = _getButton();
				domUtils.addEvents(api.video(), 'webkitpresentationmodechanged', function () {
					var pipButtonLabel = _getElement(CLASSNAMES.pipButtonLabel),
							placeholderElement = _getVideoPlaceholder(),
							labelText;

					if (api.video().webkitPresentationMode === 'picture-in-picture') {
						domUtils.addClass(api.element(), UIConstants.STATE_CLASS.pipMode);
						api.data().allowNoUi = false;
						api.fire('showControls', { shouldShow: true });
						labelText = 'Avsluta Bild-i-bild';
						domUtils.removeClass(pipButton, BUTTON_ICONS.pipButton);
						domUtils.addClass(pipButton, BUTTON_ICONS.pipButtonEnd);
						api.element().insertBefore(placeholderElement, api.video());
					} else {
						placeholderElement.parentElement.removeChild(placeholderElement);
						domUtils.removeClass(api.element(), UIConstants.STATE_CLASS.pipMode);
						api.data().allowNoUi = true;
						labelText = 'Aktivera Bild-i-bild';
						domUtils.removeClass(pipButton, BUTTON_ICONS.pipButtonEnd);
						domUtils.addClass(pipButton, BUTTON_ICONS.pipButton);
					}

					pipButton.setAttribute('title', labelText);
					pipButtonLabel.innerHTML = labelText;
				}, EVENT_NAMESPACE);

				api.on(EVENT_NAMESPACE + '.playing', domUtils.show.bind(this, pipButton));
				api.on(EVENT_NAMESPACE + '.ended', domUtils.hide.bind(this, pipButton));
			}

		});

		function _togglePictureInPicture(e) {
			e.stopPropagation();
			e.preventDefault();
			var newMode = api.video().webkitPresentationMode === 'picture-in-picture' ? 'inline' : 'picture-in-picture';
			api.video().webkitSetPresentationMode(newMode);
		}

		function _getButton() {
			var button = Sizzle('.' + CLASSNAMES.pipButton, api.element())[0];

			if (!button) {
				button = domUtils.fromString(
						'<button class="svp_pictureinpicture-button ' + CLASSNAMES.pipButton + '"\
							aria-live="assertive"\
							title="Aktivera Bild-i-bild"\
							tabindex="0">\
								<span class="svp_ui-controls__hidden ' + CLASSNAMES.pipButtonLabel + '">Aktivera Bild-i-bild</span>\
							</button>');
				domUtils.addEvents(button, 'click, touchend', _togglePictureInPicture, EVENT_NAMESPACE);

				domUtils.hide(button);
				api.insertButton(button);
			}

			return button;
		}

		function _getVideoPlaceholder() {
			var placeholder = _getElement(CLASSNAMES.placeholderContainer);
			if (placeholder) {
				return placeholder;
			}

			return domUtils.fromString(
					'<div class="svp_pictureinpicture-placeholder ' + CLASSNAMES.placeholderContainer + '">\
						<div class="svp_pictureinpicture-placeholder__image"></div>\
						<div class="svp_pictureinpicture-placeholder__text">\
							<p>Bild-i-bild aktiverat</p>\
						</div>\
					</div>'
			);
		}

	},
	destroy: function (api) {
		var button = Sizzle('.svp_pictureinpicture-button', api.element())[0];
		if (button) {
			button.parentElement.removeChild(button);
			domUtils.removeEvents(api.video(), 'webkitpresentationmodechanged', EVENT_NAMESPACE);
			api.off(EVENT_NAMESPACE + '.playing');
			api.off(EVENT_NAMESPACE + '.ended');
		}

		api.off(EVENT_NAMESPACE + '.ready');
	}
};



// WEBPACK FOOTER //
// ./src/js/plugins/pictureinpicture.js